import React from 'react';
import { Link } from 'react-router-dom';

import { Routes } from '@share/constants';

import './style.scss';

interface IProps {
  accountName: string;
}

export function ModernHero(props: IProps) {
  const { accountName } = props;

  return (
    <section className="modern-hero">
      <div className="modern-hero__background" />
      <div className="modern-hero__overlay" />

      <div className="modern-hero__content">
        <p className="modern-hero__label">YOUR NEXT ADVENTURE AWAITS</p>
        <h1 className="modern-hero__title">
          Discover the World,
          <br />
          Without the Price Tag
        </h1>
        <p className="modern-hero__description">
          Access exclusive member rates on luxury accommodations, cruise experiences, and travel
          services worldwide.
        </p>
        <div className="modern-hero__actions">
          <Link
            to={`/${accountName}${Routes.Search}`}
            className="modern-hero__button modern-hero__button--primary"
          >
            Start Searching
          </Link>
        </div>
      </div>
    </section>
  );
}
